/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneArticleFooter as ResolvedStandaloneArticleFooter } from 'base/components/standalone/ArticleFooter';

export const ArticleFooter: typeof ResolvedStandaloneArticleFooter = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneArticleFooter {...props} />
    );
});

export type ArticleFooterProps = PropsFromComponent<typeof ArticleFooter>;

/** @deprecated Use slot architecture instead */
export const ArticleFooterWith = (extras: DynamicStandaloneExtras): typeof ArticleFooter => {
    return function ArticleFooter(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleFooter');
        return <ResolvedStandaloneArticleFooter {...mergeProps({ options: { theme } }, props)} />;
    }
}